export default __webpack_public_path__ + "static/media/public-transport.a2dffe5d.svg";